<app-deprecated-modal #defaultQuestions>
    <app-segment-header title="forms.applicant-tracker.defaultApplicationQuestions"></app-segment-header>
    <img src="assets/img/applicant-tracker/default-application-questions.png" />
</app-deprecated-modal>

<app-deprecated-confirmation-dialog
    #confirmDeleteDocumentDialog
    header="applicant-tracker.deleteDocument"
    [description]="deleteModalMessage"
    [negative]="true"
    [label]="'delete'"
></app-deprecated-confirmation-dialog>

<div class="ui basic segment" [class.loading]="isLoading">
    <app-job-posting-header [jobPosting]="jobPosting" (onChangePause)="onPause($event)"></app-job-posting-header>

    <form #form="ngForm" autocomplete="off">
        <app-additional-questions-card
            [questions]="atsAdditionalQuestions"
            [jobPosting]="jobPosting"
            [isLoading]="isLoading"
            [saveUsingHttp]="true"
            (refreshData)="refreshTable()"
        ></app-additional-questions-card>

        <app-auto-archiving-questions-card
            [questions]="atsAutoArchivingQuestions"
            [jobPosting]="jobPosting"
            [isLoading]="isLoading"
            [saveUsingHttp]="true"
            (refreshData)="refreshTable()"
        ></app-auto-archiving-questions-card>

        <app-consent-card *ngIf="hasConsentFlag" [jobPosting]="jobPosting"></app-consent-card>

        <!-- Attachments container -->
        <ui-card role="group" aria-labelledby="attachments-header">
            <app-segment-header id="attachments-header" [title]="'applicant-tracker.attachments'"></app-segment-header>
            <form *ngIf="jobAttachments.length" #attachmentForm="ngForm" autocomplete="off">
                <div class="margin-bottom-2" *ngFor="let jobAttachment of jobAttachments; let i = index">
                    <div class="app-grid centered">
                        <mat-form-field class="columns-2">
                            <mat-label>{{ 'forms.applicant-tracker.name' | translate }}</mat-label>
                            <input
                                [(ngModel)]="jobAttachment.name"
                                type="text"
                                matInput
                                [name]="'attachmentName-' + i"
                                [attr.name]="'attachmentName-' + i"
                                placeholder="{{ 'forms.applicant-tracker.fileName' | translate }}"
                                #nameField="ngModel"
                                required
                                (change)="onJobAttachmentChange()"
                            />
                            <mat-error *ngIf="nameField.invalid">{{ nameField.errors | formErrors }}</mat-error>
                        </mat-form-field>
                        <mat-form-field class="columns-2">
                            <mat-label appRemoveAriaOwns>{{
                                'forms.applicant-tracker.documentType' | translate
                            }}</mat-label>
                            <mat-select
                                [(ngModel)]="jobAttachment.jobAttachmentTypeId"
                                [name]="'jobAttachmentTypes-' + i"
                                [attr.name]="'jobAttachmentTypes-' + i"
                                placeholder="{{ 'forms.applicant-tracker.attachmentType' | translate }}"
                                (selectionChange)="onJobAttachmentChange()"
                                required
                                #attachmentTypeField="ngModel"
                            >
                                <mat-option [value]="jobAttachmentTypes.File">
                                    {{ 'forms.applicant-tracker.file' | translate }}
                                </mat-option>
                                <mat-option [value]="jobAttachmentTypes.Text">
                                    {{ 'forms.applicant-tracker.link' | translate }}
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="attachmentTypeField.invalid">{{
                                attachmentTypeField.errors | formErrors
                            }}</mat-error>
                        </mat-form-field>
                        <div class="columns-1">
                            <ui-button (click)="removeJobAttachment(jobAttachment)" type="ghost">
                                <mat-icon svgIcon="close" />{{
                                    'forms.applicant-tracker.remove' | translate
                                }}</ui-button
                            >
                        </div>
                    </div>
                    <mat-checkbox
                        (change)="onJobAttachmentChange()"
                        [name]="'isRequired-' + i"
                        [(ngModel)]="jobAttachment.isRequired"
                    >
                        <span>{{ 'forms.applicant-tracker.required' | translate }}</span>
                    </mat-checkbox>
                </div>

                <div class="app-grid">
                    <ui-button (click)="addJobAttachment(); onJobAttachmentChange()" type="link"
                        ><mat-icon svgIcon="plus" />{{ 'forms.applicant-tracker.addAttachment' | translate }}</ui-button
                    >
                </div>
                <div class="flex justify-end" style="justify-content: flex-end">
                    <ui-button
                        name="saveAttachments"
                        [disabled]="!jobAttachmentChange"
                        (click)="onSaveJobAttachments()"
                        type="primary"
                        >{{ 'save' | translate }}</ui-button
                    >
                </div>
            </form>
            <ng-container *ngIf="!jobAttachments.length">
                <h4>{{ 'applicant-tracker.noAttachments' | translate }}</h4>
                <div class="app-grid">
                    <ui-button (click)="addJobAttachment(); onJobAttachmentChange()" type="link"
                        ><mat-icon svgIcon="plus" />{{ 'forms.applicant-tracker.addAttachment' | translate }}</ui-button
                    >
                </div>
            </ng-container>
        </ui-card>

        <app-required-fields-card
            (onSelect)="onSelectOptionalField($event)"
            [jobPosting]="jobPosting"
        ></app-required-fields-card>

        <!--Auto score-->
        <div class="ui segment" *ngIf="jobPosting">
            <div style="max-width: 700px">
                <app-segment-header
                    title="forms.applicant-tracker.autoScoringApplicants"
                    subtitle="forms.applicant-tracker.youCanProvideKeywords"
                ></app-segment-header>

                <ui-chips-autocomplete
                    label="forms.applicant-tracker.keywords"
                    allowAdditions="true"
                    [selectedItems]="initialKeywords"
                    (changes)="onChangeKeywords($event)"
                >
                </ui-chips-autocomplete>
            </div>
        </div>
    </form>
</div>
